module.exports = __webpack_public_path__ + "media/images/swifticons/weather-cloudy-12e6bda8cfd46b2fae6ff5329a5d068a.svg";